import { create } from 'zustand';
import { ItemSaldo } from '../../../@types';
import { ItensSaldoService } from '../../../services';

type RecomendacaoSemeaduraState = {
  cultivares: ItemSaldo[];
};

type RecomendacaoSemeaduraActions = {
  fetchCultivares: (propriedadeId: number) => Promise<void>;
  setCultivares: (cultivares: ItemSaldo[]) => void;
  clear: () => void;
};

const initialState = {
  cultivares: [],
};

const useRecomendacaoSemeaduraStore = create<
  RecomendacaoSemeaduraState & RecomendacaoSemeaduraActions
>((set) => ({
  ...initialState,

  clear: () => set(initialState),

  fetchCultivares: async (propriedadeId: number) => {
    const itensSaldo = await ItensSaldoService.saldos({
      propriedadeId,
      operacaoItem: 'cultivar',
    });

    set({ cultivares: itensSaldo });
  },

  setCultivares: (cultivares: ItemSaldo[]) => set({ cultivares }),
}));

export default useRecomendacaoSemeaduraStore;
